import { APP_BACKGROUND_COLOR, APP_COLOR, APP_HOVER_COLOR, FONT_FAMILY, TEXT_COLOR } from "../../theme";

export const mintAddCollaboratorModalStyles = {
  modalBody: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: APP_BACKGROUND_COLOR,
  } as const,
};

export const mintKeysStyles = {
  mainLabel: {
    marginBottom: 0,
    fontFamily: FONT_FAMILY,
    fontWeight: "bold",
    color: TEXT_COLOR,
  } as const,
  minor: {
    textTransform: "none",
    fontSize: 14,
    fontFamily: FONT_FAMILY,
  } as const,
  major: {
    textTransform: "none",
    fontSize: 14,
    fontFamily: FONT_FAMILY,
  },
};


export const mintManageCreatorsStyles = {
  priceInput: {
    backgroundColor: APP_BACKGROUND_COLOR,
    color: TEXT_COLOR,
  }as const,
  ethereumImage:{
    width: 25,
    marginLeft: 5,
    backgroundColor: APP_BACKGROUND_COLOR,
    color: "white",
  }as const,
  creatorUserNameLabel: {
    display: "block",
    fontFamily: FONT_FAMILY,
    fontSize: 16,
    marginBottom: 8,
    fontWeight: "bold",
    color: TEXT_COLOR,
  }as const,
  addCreatorTypography: {
    fontFamily: FONT_FAMILY,
    fontSize: 20,
    fontWeight: "bold",
  }as const,
  addCreatorButton: {
    textTransform: "none",
    color: "black",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    backgroundColor: APP_COLOR,
    marginY: 3,
    marginTop: -9,
    paddingY: 1,
  }as const,
}

export const mintPageModalGroupStyles = {
  modalBody: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: APP_BACKGROUND_COLOR,
  }as const
}

export const mintTermsAndConditionsStyles ={
  container: {
    display: "inline-block",
    verticalAlign: "top",
    marginTop: 20,
    color: TEXT_COLOR,
  }as const,
  uploadingMediaSpan: {
    marginLeft: 10,
    fontFamily: FONT_FAMILY,
    fontSize: "20px",
  }as const,
  publishMintTypography: {
    fontFamily: FONT_FAMILY,
    fontSize: 20,
    fontWeight: "bold",
  }as const
}

export const mintUploadArtWorkStyles = {
  imageIcon: {
    color: TEXT_COLOR,
    width: "50px",
    height: "50px",
  }as const
}

export const mintUploadAudioStyles={
  fileSupported: {
    fontSize: "12px",
    opacity: "0.6",
    fontFamily: FONT_FAMILY,
    marginBottom: 0,
    color: TEXT_COLOR,
  }as const
}